import React, { Component } from "react";
import { Accessor, ColorX, GFunc, IconX, LocaleX, ResponsiveX } from "IZOX/STATIC";
import { ActivityIndicator, HStack, VStack, XButton, XDiv, XImage, XText } from "IZOX/_X";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { observer } from "mobx-react";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import Breadcrumb from "shared/Breadcrumb";
import { SysConfig } from "__SYSDefault/Config";
import APIExpress from "__SYSDefault/APIs/APIExpress";
import HContactInfo from "shared/HContactInfo";
import _ from "lodash";
import Styles from "__SYSDefault/Styles";
import HContactInfoM from "shared/HContactInfoM";
import FooterM from "shared/FooterM";

/**
 * @augments {Component<Props, State>}
 */
class PGeneralInsurance extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates(() => {
      this._GetInfo();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PGeneralInsurance.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    if(this.interval) clearInterval(this.interval);
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _setTimeout = (func, delay) => {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(func, delay);
  }

  _setInterval = (func, interval) => {
    if(this.interval) clearInterval(this.interval);
    this.interval = setInterval(func, interval);
  }

  _GetInfo = async () => {
    let info = await APIExpress.WebSettings.GetInfo();
    this.setState({
      info: info
    });
  }

  renderBreadcrumb(){
    return (
      <HStack HAlign="[">
        <Breadcrumb 
          steps={[
            {
              caption: {
                EN: "Home",
                TC: "主頁"
              },
              target: "Home"
            }
          ]}
          last={{
            EN: "General Insurace",
            TC: "一般保險"
          }}/>
      </HStack>
    );
  }

  renderCard(o, i){
    let {title, icon, url} = o;
    return (
      <VStack key={i} bgColor={ColorX.CSS("NotQuiteWhite")} 
        pV={16} spacing={9} width={"32%"} mB={16}>
        <XText fontSize={16} color={ColorX.CSS("Leaf")} textAlign="|"
          fontFamily="Noto Sans SC" height={48} bold>
          {LocaleX.Parse(title)}
        </XText>
        <XImage source={icon} width={42} height={42}/>
        <XButton {...Styles.QFBtn} width={200} padding={0} pV={8} pH={24}
          onPress={() => GFunc.Download(LocaleX.Parse(url), LocaleX.Parse(title))}>
          <HStack>
            <XText bold fontSize={16}>
              {LocaleX.Parse({
                EN: "Download",
                TC: "下載"
              })}
            </XText>
          </HStack>
        </XButton>
      </VStack>
    );
  }

  renderGI(){
    let {info} = this.state;
    let {ginsurance} = info ?? {};
    let {page} = ginsurance ?? {};

    return (
      <XDiv display="flex" flexWrap="wrap" spacing={16} justifyContent="space-between">
        {_.map(page, (o, i) => {
          return this.renderCard(o, i);
        })}
      </XDiv>
    );
  }

  renderMain(){
    let {info} = this.state;
    return (
      <VStack spacing={16} width={848} HAlign="[">
        <XText fontSize={32} color={ColorX.CSS("Stone")} bold>
          {LocaleX.Parse({
            EN: "General Insurance",
            TC: "一般保險"
          })}
        </XText>
        <XDiv>
          {this.renderGI()}
        </XDiv>
        <HStack bColor={ColorX.CSS("Blood")} bW={1} p={12} spacing={8} HAlign="[">
          {IconX.Get("feather", "info", 20, ColorX.CSS("Blood"))}
          <XText fontSize={12} color={ColorX.CSS("Blood")} bold style={{whiteSpace: "pre-line"}}>
            {LocaleX.Parse({
              EN: "The features above are indicative only. Please refer to the Product Brochure for details.\nFor a complete explanation of the terms and conditions, please call our Service Hotline at 2385-1402.",
              TC: "以上功能僅供參考，詳情請參閱產品手冊。\n如需了解條款和條件的完整說明，請撥打我們的服務熱線2385-1402。"
            })}
          </XText>
        </HStack>
        <HContactInfo info={info}/>
      </VStack>
    );
  }

  renderNormal(){
    return (
      <VStack fullWidth>
        <VStack width={SysConfig.ContentWidth} pH={80}>
          {this.renderBreadcrumb()}
          {this.renderMain()}
        </VStack>
      </VStack>
    );
  }

  renderCardM(o, i){
    let {title, icon, url} = o;
    return (
      <VStack key={i} bgColor={ColorX.CSS("NotQuiteWhite")} 
        p={16} spacing={9} fullWidth mB={16}>
        <HStack spacing={16}>
          <XImage source={icon} height={70} width={70} flexShrink={0}/>
          <VStack flexGrow={1} flexShrink={1} HAlign="[" spacing={16}>
            <XText fontSize={18} color={ColorX.CSS("Leaf")} textAlign="["
              fontFamily="Red Hat Display" bold fontWeight={800}>
              {LocaleX.Parse(title)}
            </XText>
            <XButton {...Styles.QFBtn} fullWidth padding={0} pV={8} pH={24}
              onPress={() => GFunc.Download(LocaleX.Parse(url), LocaleX.Parse(title))}>
              <HStack>
                <XText bold fontSize={16}>
                  {LocaleX.Parse({
                    EN: "Download",
                    TC: "下載"
                  })}
                </XText>
              </HStack>
            </XButton>
          </VStack>
        </HStack>
      </VStack>
    );
  }

  renderGIM(){
    let {info} = this.state;
    let {ginsurance} = info ?? {};
    let {page} = ginsurance ?? {};

    return (
      <VStack fullWidth mV={20}>
        {_.map(page, (o, i) => {
          return this.renderCardM(o, i);
        })}
      </VStack>
    );
  }

  renderContactInfoM(){
    let {info} = this.props;
    let {contactinfo} = info ?? {};
    let {phone, whatsapp, fax, email, address} = contactinfo ?? {};
    return (
      <VStack fullWidth HAlign="[">
        <VStack pV={40} fullWidth spacing={16}>
          <HStack>
            <XText fullWidth textAlign="[" color={ColorX.CSS("Stone")} bold fontSize={16}>
              {LocaleX.Parse({
                EN: "Contact Information",
                TC: "聯絡資料"
              })}
            </XText>
          </HStack>
          <HStack HAlign="[" spacing={16}>
            <HStack spacing={5} HAlign="[" width={"auto"}>
              <XImage source="/Images/Icons/phonecom.png" 
                width={24} height={24} noResize/>
              <XText color={ColorX.CSS("Stone")}>{phone}</XText>
            </HStack>
            <HStack spacing={5} HAlign="[" width={"auto"}>
              <XImage source="/Images/Icons/whatsapp.png" 
                width={24} height={24} noResize/>
              <XText color={ColorX.CSS("Stone")}>{whatsapp}</XText>
            </HStack>
            <HStack spacing={5} HAlign="[" width={"auto"}>
              <XImage source="/Images/Icons/fax.png" 
                width={24} height={24} noResize/>
              <XText color={ColorX.CSS("Stone")}>{fax}</XText>
            </HStack>
            <HStack spacing={5} HAlign="[" width={"auto"}>
              <XImage source="/Images/Icons/email.png"
                width={24} height={24} noResize/>
              <XText color={ColorX.CSS("Stone")}>{email}</XText>
            </HStack>
          </HStack>
          <HStack spacing={5} HAlign="[">
            <XImage source="/Images/Icons/location.png"
              width={24} height={24} noResize/>
            <XText color={ColorX.CSS("Stone")}>{LocaleX.Parse(address)}</XText>
          </HStack>
        </VStack>
      </VStack>
    );
  }

  renderMainM(){
    let {info} = this.state;
    return (
      <VStack spacing={16} fullWidth HAlign="[" pH={26}>
        <HStack mV={20}>
          <XText fontSize={32} color={ColorX.CSS("Stone")} bold>
            {LocaleX.Parse({
              EN: "General Insurance",
              TC: "一般保險"
            })}
          </XText>
        </HStack>
        {this.renderGIM()}
        <HStack bColor={ColorX.CSS("Blood")} bW={1} p={12} spacing={8}>
          {IconX.Get("feather", "info", 20, ColorX.CSS("Blood"))}
          <XText fontSize={12} color={ColorX.CSS("Blood")} bold fontFamily="Red Hat Display" fontWeight={400}>
            {LocaleX.Parse({
              EN: "The features above are indicative only. Please refer to the Product Brochure for details.\nFor a complete explanation of the terms and conditions, please call our Service Hotline at 2385-1402.",
              TC: "以上功能僅供參考，詳情請參閱產品手冊。\n如需了解條款和條件的完整說明，請撥打我們的服務熱線2385-1402。"
            })}
          </XText>
        </HStack>
        <HContactInfoM info={info}/>
      </VStack>
    );
  }

  renderBreadcrumbM(){
    return (
      <HStack HAlign="[" pH={26}>
        <Breadcrumb 
          steps={[
            {
              caption: {
                EN: "Home",
                TC: "主頁"
              },
              target: "Home"
            }
          ]}
          last={{
            EN: "General Insurace",
            TC: "一般保險"
          }}/>
      </HStack>
    );
  }

  renderMobile(){
    return (
      <VStack fullWidth>
        {this.renderBreadcrumbM()}
        {this.renderMainM()}
        <FooterM/>
      </VStack>
    );
  }

  render(){
    let {info} = this.state;
    if(!info){
      return (
        <VStack fullWidth fullHeight VAlign="-" HAlign="|">
          <ActivityIndicator loading size={Math.min(100, window.innerWidth * 0.5)} thickness={10}/>
        </VStack>
      );
    }
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal()
    });
  }

}

export default withRouter(observer(PGeneralInsurance));
